<aside class="sidebar">
  @if (!editedUser()) {
    <div class="sidebar_header">
      <div
        class="user-info"
        #menuTrigger="cdkMenuTriggerFor"
        [cdkMenuTriggerFor]="menu"
        [cdkMenuPosition]="menuPosition"
        [class.user-info--active]="menuTrigger.isOpen()"
      >
        <app-entity-avatar
          field="name"
          shape="rounded"
          [data]="user()"
        />
        <div class="user-info_name">{{ user()?.name }}</div>
      </div>
    </div>
  }

  <div class="sidebar_content">
    <app-sidebar-menu [items]="sidebarTopMenu()">
      <ng-template
        #menuItemTemplate
        let-menuItem
      >
        @if (menuItem?.key === 'redirect' && !!pageConfigStore.pageConfig()?.redirect_enabled) {
          <app-toggle-switch
            [ngModel]="hasRedirect"
            [readonly]="true"
            (click)="$event.preventDefault(); $event.stopPropagation(); clearRedirect()"
          />
        }
      </ng-template>
    </app-sidebar-menu>
  </div>

  <div class="sidebar_footer">
    <app-sidebar-menu [items]="sidebarBottomMenu()" />
  </div>
</aside>

<ng-template #menu>
  <div
    cdkMenu
    class="profile-menu"
  >
    <ul class="profile-menu_list">
      @for (menuItem of profileMenu(); track menuItem.title) {
        @if (menuItem.visible) {
          <li
            class="profile-menu_list__item"
            [class.profile-menu_list__item--withBorder]="menuItem.border"
            (click)="clickOnProfileMenu(menuItem)"
          >
            <div class="profile-menu_list__item-content">
              <app-svg-icon
                class="profile-menu_list__item-content--icon"
                [name]="menuItem.icon"
              />
              <span class="profile-menu_list__item-content--title">{{ menuItem.title }}</span>
            </div>
          </li>
        }
      }
    </ul>
  </div>
</ng-template>
